import React, { HTMLAttributes, useState } from "react";

import Button from "@material-ui/core/Button";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import ErrorBoundary from "components/ErrorBoundary";
import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";
import VetListsPopUp from "./VetListsPopUp";

import useStyles from "./styles";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  horse: racehorse360.IHorse;
}

const VetListCell = (props: IProps) => {
  const { horse, ...restProps } = props;

  const classes = useStyles();

  const [isVetListPopupOpened, setIsVetListPopupOpened] = useState(false);

  const handleOpenVetListPopup = () => {
    setIsVetListPopupOpened(true);
  };

  const handleCloseVetListPopup = () => {
    setIsVetListPopupOpened(false);
  };

  return (
    <TableCellWrapper {...restProps} centered>
      {Boolean(horse.totalVetListsCount) && (
        <Button
          className={classes.activeVetListsContent}
          onClick={handleOpenVetListPopup}
        >
          {horse.activeVetListsCount}
        </Button>
      )}

      {isVetListPopupOpened && (
        <ErrorBoundary>
          <VetListsPopUp horse={horse} onClose={handleCloseVetListPopup} />
        </ErrorBoundary>
      )}
    </TableCellWrapper>
  );
};

export default React.memo(VetListCell);
